import React from 'react';

const Header = () => (
  <header>
    <h1 className="header-heading">Todos</h1>
  </header>
);

export default Header;
